import "./Content.css"
import React from "react"
import { Outlet } from "react-router-dom"

function Content() {
    return (
        <main>
            <Outlet />
        </main>
    )
}

export default Content